// ─────────────────────────────────────────────
// KLOTHIQ — MutationLoadingOverlay
// FEAT-LOADER-001: a full-screen branded overlay while ANY save/create/
// update/delete is in flight, anywhere in the app. Mounted once in
// AppLayout — covers every current and future `useMutation` call site
// automatically via React Query's global mutation cache, no per-page
// wiring needed (unlike LoadingState, which each page renders itself).
// ─────────────────────────────────────────────

import { useIsMutating } from '@tanstack/react-query';
import BrandLoader from '@/components/common/BrandLoader';

export default function MutationLoadingOverlay() {
  const isMutating = useIsMutating();

  // Always mounted, `active` just toggles — this is exactly the case
  // BrandLoader's internal appearance-delay/minimum-duration debounce
  // gives a hard guarantee for (unlike LoadingState's 20 call sites,
  // which mount/unmount the whole component instead of toggling a prop).
  return <BrandLoader variant="boot" active={isMutating > 0} overlay message="Saving…" />;
}
